export default __webpack_public_path__ + "static/media/Deepak.4cd6c792.png";